import React from "react";
import InfoCard from "./InfoCard";
import { useTranslation } from "react-i18next";
import Styles from "../../../scss/orderDetails.module.scss";
import useFormatCurrency from "../../../yoello-lib/modules/localisation/useCurrency";
import { IPlacedOrder } from "../constants";
import { DiscountDetails } from "./DiscountDetails";
import { PaymentMethods } from "./PaymentMethods";

interface IPricingDetailsProps {
    placed_order: IPlacedOrder;
    orderOnly?:boolean;
}

export function PricingDetails({ placed_order, orderOnly }: IPricingDetailsProps) {
    const { t } = useTranslation();
    const { formatCurrency } = useFormatCurrency();

    let subtotal = 0;
    if (placed_order.placed_order_sum_group_discount_price) {
        subtotal = parseFloat(placed_order.placed_order_sum_group_discount_price);
    }

    return <div className={Styles.PricingDetailsSection}>
        <InfoCard isBold label={t("orderHistory.modal.total")} value={formatCurrency(placed_order.placed_order_order_total || 0)} className={Styles.BillLabels} />
        {
            !orderOnly && <>
            <InfoCard label={t("orderHistory.modal.subTotal")} value={formatCurrency(subtotal)} className={Styles.BillLabels} />
            <DiscountDetails placed_order_discount_frozen={placed_order.placed_order_discount_frozen}
                placed_order_discount_value={placed_order.placed_order_discount_value}
                placed_order_discount_code={placed_order.placed_order_discount_code} />
            {placed_order?.placed_order_ext_promotion_price && <InfoCard label={t("orderHistory.modal.Promotion")} value={`- ${formatCurrency(placed_order.placed_order_ext_promotion_price || 0)}`} className={Styles.BillLabels} wrapperClassName={Styles.PromotionValue} />}
            <InfoCard label={t("orderHistory.modal.tip")} value={formatCurrency(placed_order.placed_order_order_gratuity || 0)} className={Styles.BillLabels} />
            <InfoCard label={t("orderHistory.modal.serviceCharge")} value={formatCurrency(placed_order.placed_order_order_processing_charge || 0)} className={Styles.BillLabels} />
            {placed_order.placed_order_order_type === "HOME_DELIVERY" && <InfoCard label={t("orderHistory.modal.deliveryCharge")} value={formatCurrency(placed_order.placed_order_order_service_charge || 0)} className={Styles.BillLabels} />}
            <InfoCard label={t("orderHistory.modal.TotalTax")} value={formatCurrency(placed_order.placed_order_order_total_vat_amount || 0)} className={Styles.BillLabels} />
            {placed_order.placed_order_payment_method && <PaymentMethods method={placed_order.placed_order_payment_method!} />}
            
            </>
        }
    </div>
}